import * as React from 'react';
import { Util } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';

const ContentSuggestion = ({ suggestion , onClick ,  })=>{
    if (!suggestion.link || !suggestion.title || suggestion.link === '' || suggestion.title === '') {
        return null;
    }
    return /*#__PURE__*/ React.createElement("a", {
        className: "content-suggestion__link",
        href: suggestion.link,
        onClick: ()=>onClick && onClick(suggestion.objectID, suggestion.position)
    }, /*#__PURE__*/ React.createElement("span", {
        className: "content-suggestion__icon-wrapper"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "content",
        className: "content-suggestion__content-icon"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "content-suggestion--wrap-text"
    }, Util.truncateString(suggestion.title, 60)));
};

export { ContentSuggestion as default };
//# sourceMappingURL=ContentSuggestion.js.map
